
import CustomMultiSelectFilter from "@/components/CustomMultiSelectFilter";
import { useEffect } from "react";

interface PtpDateFilterProps {
  selectedValues: string[];
  onValueChange: (values: string[]) => void;
  availableOptions: string[];
}

const PtpDateFilter = ({ selectedValues, onValueChange, availableOptions }: PtpDateFilterProps) => {
  // Debug logging for options
  useEffect(() => {
    console.log('🔍 PtpDateFilter: Received availableOptions:', availableOptions);
    console.log('🔍 PtpDateFilter: Options length:', availableOptions?.length);
    console.log('🔍 PtpDateFilter: Selected values:', selectedValues);
  }, [availableOptions, selectedValues]);

  // Same four labels as the Daily Worklist PTP cards. The applicant API accepts these strings.
  const displayOptions = availableOptions?.length
    ? availableOptions
    : ['Today', 'Missed', 'Not Set', 'Later'];

  const handleChange = (selectedLabels: string[]) => {
    // Pass the selected display labels directly since that's what the backend expects
    onValueChange(selectedLabels);
  };

  return (
    <CustomMultiSelectFilter
      label="PTP Date"
      options={displayOptions}
      selected={selectedValues}
      onSelectionChange={handleChange}
      placeholder="Select PTP dates"
    />
  );
};

export default PtpDateFilter;
